import { FilterShop } from "../../../../../shop/frontend/web/js/classes/FilterShop.js";

let isSwitch = false;

/**
 *  Класс описывающий реализацию фильтра
 * @extends FilterShop
 */
export class Filter extends FilterShop {
	constructor() {
		super();
		this.$filterClear = $("#js-filter-clear");
		this.$filters = $(".js-filter-input");
		this.$items = $("#js-event-items");
		this.$more = $(".js-more");
		this.$message = $("#js-events-message");
		this.$calendarInput = $(".js-date-filter");
		this.$calendarLabel = $("#js-filter-label");
		this.$filterTitle = $("#js-filter-title");
		this.$filterWrapper = $("#js-filter-wrapper");
		this.$filterSwitch = $("#js-filter-switch");
		this.$filterSwitchInput = $("#js-switch-input");
		this.$dropdownTypes = $(".js-dropdown-types");
		this.$cleanTypes = this.$dropdownTypes.find(".js-filter-reset");
		this.changeTypes();
	}

	setActionMore() {
		this.$more.on("click", e => {
			const $element = $(e.currentTarget);
			this.$items = $element.parents(".events").find(".js-event-items");
			let page = $element.data("page");
			page++;
			$element.data("page", page);
			this.page = page;
			this.eventTypes.push("match");
			this.getRequest("append");
		});

		this.$filterSwitchInput.on("change", e => {
			const element = $(e.currentTarget);
			this.page = 0;

			if (!element.is(":checked")) {
				this.hasParking = false;
				this.$filterSwitch.removeClass("active");
				this.$filterClear.addClass("active");
			} else {
				this.$filterSwitch.addClass("active");
				this.hasParking = true;
			}

			this.getRequest();
		});
	}

	changeTypes() {
		const checkboxes = this.$dropdownTypes.find(".checkbox__input");
		const allEvents = $(`.events_main`);

		function changeCheckbox() {
			let notSelected = 0;
			$.each(checkboxes, (index, el) => {
				const type = $(el).data("select");
				const currentEvents = $(`.events_main[data-type="${type}"]`);

				if (el.checked) {
					currentEvents.show();
				} else {
					notSelected++;
					currentEvents.hide();
				}
			});

			if (checkboxes.length === notSelected) {
				allEvents.show();
			}
		}

		checkboxes.each((i, item) => {
			$(item).on("change", () => {
				changeCheckbox();
			});

			$(item).on("keydown", e => {
				if (e.code === "Enter" || e.code === "NumpadEnter") {
					changeCheckbox();
				}
			});
		});

		this.$cleanTypes.on("click", () => {
			checkboxes.each((i, item) => {
				item.checked = false;
			});
			allEvents.show();
		});
	}
}
